import { CustomAction } from '../../hooks/useCustomAction/useCustomAction.type';
import { Application } from '../../providers/Applications.types';

export const PrimeAppList = ['APPLICATION_IDENTIFIER_PRIME'];

export function getNotPrimeApps(applications: Application[]) {
  return applications.filter((app) => !PrimeAppList.includes(app.applicationId));
}

export function generateCallToAction({
  toggleOn,
  setApplicationById,
}: {
  toggleOn: () => void;
  setApplicationById: (applicationId: string) => void;
}) {
  return (applicationId: string): CustomAction => {
    return {
      applicationId,
      action: () => {
        toggleOn();
        setApplicationById(applicationId);
      },
    };
  };
}
